import { UpdateTermineFormProps } from '@/domain/termine/features/UpdateTermin/shared/types';
import { useTranslation } from 'react-i18next';

export function InputFormField({ form }: UpdateTermineFormProps) {
  const { t } = useTranslation();

  return (
    <form.AppField name="titel">
      {(field) => (
        <field.TextInput
          label={t('domain.termine.sheet.fields.titel')}
          isRequired
        />
      )}
    </form.AppField>
  );
}
